import { ColorSwatch } from '@mantine/core';
import { useTranslation } from 'react-i18next';

type GeneratedTableCellPropsType = {
  generated: boolean;
};

export const GeneratedTableCell: React.FC<GeneratedTableCellPropsType> = ({
  generated,
}) => {
  const { t } = useTranslation();

  if (!generated) {
    return t('NO_DATA_PLACEHOLDER');
  }

  return (
    <ColorSwatch
      component="span"
      color="var(--mantine-color-green-6)"
      size={10}
      withShadow={false}
      aria-label={t('REPORTS.HISTORY.TABLE_COLUMNS.GENERATED')}
    />
  );
};
